import {  Component, Vue } from "vue-property-decorator"
import { financeRefundStatisticalData, financeRefundStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'
import commonData from "@/utils/commonData";

@Component({})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  souCourseName = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'customerName', cnFilds: '客户名称', isShow: true, id: 1 },
    { filds: 'souCourseName', cnFilds: '项目名称', isShow: true, id: 2 },
    { filds: 'souCourseType', cnFilds: '项目类型', isShow: true, id: 3 },
    { filds: 'marketCooperationName', cnFilds: '合作伙伴名称', isShow: true, id: 4 },
    { filds: 'marketCooperationTypes', cnFilds: '合作方类型', isShow: true, id: 5 },
    { filds: 'financeRefundPrice', cnFilds: '退款金额', isShow: true, id: 6 },
    { filds: 'refundAt', cnFilds: '退款时间', isShow: true, id: 7 },
    { filds: 'code', cnFilds: '退款编号', isShow: true, id: 8 },
    { filds: 'refundCause', cnFilds: '退款原因', isShow: true, id: 9 },
    { filds: 'financeOrderCode', cnFilds: '订单编号', isShow: true, id: 10 },
    { filds: 'commissionType', cnFilds: '佣金类型', isShow: true, id: 11 },
    { filds: 'ratio', cnFilds: '返点比例', isShow: true, id: 12 },
    { filds: 'financeOrderPrice', cnFilds: '订单金额', isShow: true, id: 13 },
    { filds: 'financeRepeatOrderFlag', cnFilds: '撞单', isShow: true, id: 14 },
    { filds: 'marketClueDirectorUserRealName', cnFilds: '市场负责人', isShow: true, id: 15 },
    { filds: 'financeOrderCreatedUserRealName', cnFilds: '订单创建人', isShow: true, id: 16 },
    { filds: 'financeOrderCooperationUserRealName', cnFilds: '合作成单同事', isShow: true, id: 17 },
    { filds: 'financeOrderAchievementRatio', cnFilds: '业绩比例分配', isShow: true, id: 18 },
    { filds: 'customerDirectorUserRealName', cnFilds: '客户负责人', isShow: true, id: 19 },
    { filds: 'marketChannelType', cnFilds: '渠道类型', isShow: true, id: 20 },
    { filds: 'marketClueCreatedUserRealName', cnFilds: '市场线索创建人', isShow: true, id: 21 },
    { filds: 'financeMarketCostSum', cnFilds: '市场费用金额', isShow: true, id: 22 },
    { filds: 'souCoursePrice', cnFilds: '项目终端售价', isShow: true, id: 23 },
    { filds: 'discountPrice', cnFilds: '优惠金额', isShow: true, id: 24 },
  ]
  customerName = '' //客户名称
  marketCooperationName = ''
  timer = null
  refundCause = ''
  souCourseTypeIdList = []
  typeList = commonData.projectTypeArray

  created() {
    this.getTableData()
  }

  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true
    const { allNum, financeRefundList } = await financeRefundStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      customerName : this.customerName,
      marketCooperationName : this.marketCooperationName,
      souCourseName : this.souCourseName,
      refundCause : this.refundCause,
      souCourseTypeIdList : this.souCourseTypeIdList,
    })) as unknown as { allNum: number; financeRefundList: any[] }
    this.tableData = financeRefundList
    this.total = allNum
    this.tableLoading = false
  }

  // 导出
  async exportExcel(keys: string = '') {
    this.exportButtonDisabled = true
    await financeRefundStatisticalDataExport(
        delNullProperty(
        {
          customerName: this.customerName,
          marketCooperationName: this.marketCooperationName,
          souCourseName : this.souCourseName,
          refundCause : this.refundCause,
          souCourseTypeIdList : this.souCourseTypeIdList,
          keys,
        })
    ).then(()=>{
      this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    })
        .finally(() => {
      this.exportButtonDisabled = false
    })
  }


  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
          this.page = page
          this.getTableData()
        }, 1000
    )
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

}